import DividerText from './DividerText';

export { DividerText };
export default DividerText;
